import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDropDownBoxComponent, DxTreeViewComponent } from 'devextreme-angular';
import { Subscription } from 'rxjs';
import { RapportIncidentTypeIncident } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';

@Component({
  selector: 'app-rapport-incident-lieu-multi-select',
  templateUrl: './rapport-incident-lieu-multi-select.component.html',
  styleUrls: ['./rapport-incident-lieu-multi-select.component.css']
})
export class RapportIncidentLieuMultiSelectComponent implements OnInit {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('lieuxTree') lieuxTree: DxTreeViewComponent;

  @Input() width: number;
  @Input() widthPopUp: number = 250;

  @Input() typeIncident: RapportIncidentTypeIncident;

  @Input() LieuIds: number[];
  @Input() titleNull: string;
  @Output() LieuIdsChange = new EventEmitter<number[]>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  placeholder: string;

  Lieux: any[];
  ColumnName = [];

  LieuxExplosion = [];
  LieuxVols = [];
  LieuxAgression = [];

  selectionMode: string;

  constructor(private panelLayoutService: PanelLayoutService,
    private translateService: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translateService.getBrowserLang());
  }

  ngOnInit() {
    this.LieuxExplosion.push({id: 0, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Conteneur')});
    this.LieuxExplosion.push({id: 1, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.DSM')});
    this.LieuxExplosion.push({id: 2, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Autre')});
    
    this.LieuxVols.push({id: 3, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Metaux')});
    this.LieuxVols.push({id: 4, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.DEEE')});
    this.LieuxVols.push({id: 5, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.DSM')});
    this.LieuxVols.push({id: 6, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Bureau')});
    this.LieuxVols.push({id: 7, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Outillage')});
    this.LieuxVols.push({id: 8, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Autre')});

    this.LieuxAgression.push({id: 9, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Accueil')});
    this.LieuxAgression.push({id: 10, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Conteneur')});
    this.LieuxAgression.push({id: 11, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Dalle')});
    this.LieuxAgression.push({id: 12, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.LocauxSociaux')});
    this.LieuxAgression.push({id: 13, name: this.translateService.instant('Rapports.RapportsIncidents.Lieux.Autre')});

    switch(this.typeIncident) {
      case RapportIncidentTypeIncident.Explosion:
        this.Lieux = this.LieuxExplosion;  
        this.selectionMode = "single";
        this.placeholder = this.translateService.instant("SelectLieu");
      break;
      case RapportIncidentTypeIncident.Vols:
        this.Lieux = this.LieuxVols;  
        this.selectionMode = "multiple";
        this.placeholder = this.translateService.instant("SelectLieux");
        break;
      case RapportIncidentTypeIncident.Agression:
        this.Lieux = this.LieuxAgression;  
        this.selectionMode = "single";
        this.placeholder = this.translateService.instant("SelectLieu");
        break;
    }

    if (this.LieuIds) {
      this.updateSelection(this.lieuxTree?.instance);
    }
  }

  onLieuSelectionChanged(e) {
    this.LieuIds = [... e.component.getSelectedNodeKeys()];
    if (this.InitId != this.LieuIds && !!this.cell) {
      this.cell.setValue(this.LieuIds);
    }
    this.LieuIdsChange.emit(this.LieuIds);
  }

  onContentReady(e) {
    this.updateSelection(e.component);
  }

  updateSelection(lieu) {
    let lieuIds = [...this.LieuIds];
    if (!lieu) return;

    if(this.LieuIds) {
      lieu.unselectAll();
      lieuIds.forEach((value) => {
        let lieuToSelect = this.Lieux.find(p => p.id == value);
        if (lieuToSelect) {
          lieu.selectItem(lieuToSelect);
        }
      });
    }
  }

  onOpened() {
    switch(this.typeIncident) {
      case RapportIncidentTypeIncident.Explosion:
        this.Lieux = this.LieuxExplosion;  
        this.selectionMode = "single";
        this.placeholder = this.translateService.instant("SelectLieu");
      break;
      case RapportIncidentTypeIncident.Vols:
        this.Lieux = this.LieuxVols;  
        this.selectionMode = "multiple";
        this.placeholder = this.translateService.instant("SelectLieux");
        break;
      case RapportIncidentTypeIncident.Agression:
        this.Lieux = this.LieuxAgression;  
        this.selectionMode = "single";
        this.placeholder = this.translateService.instant("SelectLieu");
        break;
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}

